import { render, staticRenderFns } from "./AdminTopNavItems.vue?vue&type=template&id=7476880a"
import script from "./AdminTopNavItems.vue?vue&type=script&lang=js"
export * from "./AdminTopNavItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports